import React, {Component} from "react"
import styles from "./Footer.module.css"
import nauLogo from "../Header/parts/img/NAU80thLogo.png"

const campuses = [
    {
        id: 1,
        region_id: 1,
        name: "Rapid City",
        code: "Rapid City",
        address: "4020 Jackson Blvd Suite 1 Rapid City, SD 57702",
        state: "",
        phone: "800-209-0182",
        school_code: "",
        region: {
            id: 1,
            state: "South Dakota",
            region: "South Dakota"
        }
    }
]

const social = [
    {
        id: 1,
        name: "Facebook",
        link: "https://www.facebook.com/NationalAmericanU",
        icon: "fa fa-facebook"
    },
    {
        id: 2,
        name: "Instagram",
        link: "https://www.instagram.com/natamericanu",
        icon: "fa fa-instagram"
    },
    {
        id: 3,
        name: "Twitter",
        link: "https://twitter.com/NatAmericanU",
        icon: "fa fa-twitter"
    },
    {
        id: 4,
        name: "LinkedIn",
        link: "https://www.linkedin.com/school/national-american-university",
        icon: "fa fa-linkedin"
    }
]

interface Props {}

export class Footer extends Component<Props, {}> {
    public render() {
        return (
            <footer className={styles.root}>
                <div className={styles.wrapper}>
                    <div>
                        <div>
                            <img src={nauLogo} alt="nau-logo" className={styles.logo} />
                        </div>
                        <div className={styles.social}>
                            {social.map(({id, link, icon}) => (
                                <a
                                    href={link}
                                    className={icon}
                                    key={id}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {""}
                                </a>
                            ))}
                        </div>
                    </div>
                    <div className={styles.campuses}>
                        <h5>
                            <strong>CAMPUS LOCATION</strong>
                        </h5>
                        {campuses.map(({code, address, phone, id}) => (
                            <div className={styles.campusContainer} key={id}>
                                <div className={styles.code}>
                                    <strong>{code}</strong>
                                </div>
                                <div className={styles.address}>{address}</div>
                                <div className={styles.phone}>
                                    <strong>Ph:</strong> {phone}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </footer>
        )
    }
}
